import React, { memo } from 'react';
import PropTypes from 'prop-types';
import Table from '../reusable/Table';
import { FlexContainer, FlexItem } from '../../styled/layout.styled';
import Pagination from '../reusable/Pagination';
import DropDown from '../reusable/DropDown/DropDown';

const headerTitles = {
  created_at: 'Time',
  receiver_address: 'Receiver Address',
  tx_id: ' TxID',
  amount: 'Amount',
};

const listItems = [
  { name: 'Last 24 Hours', value: '24h' },
  { name: 'Last 3 Days', value: '3d' },
  { name: 'Last 7 Days', value: '7d' },
];

const Payouts = ({
  pagination,
  prevPage,
  nextPage,
  changePage,
  onCLickHandler,
  value,
  trigger,
  setTrigger,
  payout,
  loaded,
  payoutTotalPages,
}) => (
  <>
    <Table headerTitles={headerTitles} bodyValues={payout} rowKey="tx_id" transactions />
    {payoutTotalPages > 1 && loaded ? (
      <FlexContainer justifyContent="flex-end" alignItems="baseline" tabletJustifyContent="center" margin="16px 0 0 0">
        <FlexItem margin="0 93px 0 0" tabletMargin="0">
          <Pagination pagination={pagination} prevPage={prevPage} nextPage={nextPage} changePage={changePage} margin />
        </FlexItem>
        <FlexContainer justifyContent="flex-end" tabletDisplay="none">
          {payout.length ? (
            <FlexItem width="180px">
              <DropDown
                onCLickHandler={onCLickHandler}
                value={value}
                listItems={listItems}
                defaultValue="Export CSV"
                trigger={trigger}
                setTrigger={setTrigger}
                transactionsIcon
              />
            </FlexItem>
          ) : null}
        </FlexContainer>
      </FlexContainer>
    ) : null}
  </>
);

Payouts.propTypes = {
  pagination: PropTypes.array.isRequired,
  prevPage: PropTypes.func.isRequired,
  nextPage: PropTypes.func.isRequired,
  changePage: PropTypes.func.isRequired,
  onCLickHandler: PropTypes.func.isRequired,
  value: PropTypes.objectOf(PropTypes.any).isRequired,
  trigger: PropTypes.bool.isRequired,
  setTrigger: PropTypes.func.isRequired,
  payout: PropTypes.arrayOf(PropTypes.any).isRequired,
  loaded: PropTypes.bool.isRequired,
  payoutTotalPages: PropTypes.number.isRequired,
};

export default memo(Payouts);
